import {
	type Action,
	createActionsHook,
	createHook,
	createSelector,
	createStore,
} from 'react-sweet-state';

type SpotlightState = {
	spotlight:
		| {
				state: 'hidden';
		  }
		| {
				state: 'visible';
				activeSpotlight: number;
		  }
		| {
				state: 'seen';
		  }
		| {
				state: 'dismiss';
		  };
};

const initialState: SpotlightState = {
	spotlight: { state: 'hidden' },
};

const actions = {
	start:
		(): Action<SpotlightState> =>
		({ getState, setState }) => {
			const { spotlight } = getState();
			if (spotlight.state !== 'hidden') {
				return;
			}

			setState({ spotlight: { state: 'visible', activeSpotlight: 0 } });
		},
	end:
		(): Action<SpotlightState> =>
		({ setState }) => {
			setState({ spotlight: { state: 'seen' } });
		},
	dismiss:
		(): Action<SpotlightState> =>
		({ setState }) => {
			setState({ spotlight: { state: 'dismiss' } });
		},
};

const SpotlightStore = createStore({
	initialState,
	actions,
	name: 'SpotlightStore',
});

export const useSpotlightActions: import('react-sweet-state').HookActionsFunction<
	import('react-sweet-state').BoundActions<
		SpotlightState,
		{
			start: () => Action<SpotlightState>;
			end: () => Action<SpotlightState>;
			dismiss: () => Action<SpotlightState>;
		}
	>
> = createActionsHook(SpotlightStore);

export const useSpotlightStore: import('react-sweet-state').HookFunction<
	SpotlightState,
	import('react-sweet-state').BoundActions<
		SpotlightState,
		{
			start: () => Action<SpotlightState>;
			end: () => Action<SpotlightState>;
			dismiss: () => Action<SpotlightState>;
		}
	>,
	void
> = createHook(SpotlightStore);

export const useSpotlightState: import('react-sweet-state').HookFunction<
	| {
			state: 'hidden';
	  }
	| {
			state: 'visible';
			activeSpotlight: number;
	  }
	| {
			state: 'seen';
	  }
	| {
			state: 'dismiss';
	  },
	import('react-sweet-state').BoundActions<
		SpotlightState,
		{
			start: () => Action<SpotlightState>;
			end: () => Action<SpotlightState>;
			dismiss: () => Action<SpotlightState>;
		}
	>,
	void
> = createHook(SpotlightStore, {
	selector: createSelector(
		(state) => state.spotlight,
		(spotlightState) => spotlightState,
	),
});
